import { useEffect } from "react";
import Process from '../table/Tableprocess';
import Modal from "../modal/Modalprocess"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Process/>
    
     
     </>
  );
};

export default Dashboard;
